import { ContactHero } from './ContactHero';

export type { ContactHeroProps } from './types';
export default ContactHero;
